import {DatasetDataInfoResponse} from "api/model/dataset/DatasetDataInfoResponse";
import {NodeValues, SankeyDiagramGraph} from "components/dashboard/charts/sankey-chart/sankey-types";
import {addToDate, ChronoUnitLegacy, dateToReadableString, truncateDate} from "utils/time-utils";

export const minimalNumber = 0.000000000001;

export const validatedConfigIsCorrect = (graph: SankeyDiagramGraph): string => {
    const nodesId = graph.nodes.map(e => e.id);

    let correct: string = "";
    graph.links.forEach((l) => {
        if (!nodesId.includes(l.source)) {
            correct = l.source;
        }
        if (!nodesId.includes(l.target)) {
            correct = l.target;
        }
    });

    return correct;
};

export const findResponseByIdentifier = (data: Array<DatasetDataInfoResponse>, givenIdentifier: string): DatasetDataInfoResponse | undefined => {
    return data.find(item => item.identifier === givenIdentifier);
};

export const getPercentage = (value: number, fullVal: number) => {
    return fullVal > 0 ? (value * 100) / fullVal : 0;
};

export function extractValueByNodeName(arr: NodeValues[], nodeName: string) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].nodeName === nodeName) {
            return arr[i].value;
        }
    }
    return undefined;
}

export const extractUniqueNames = (
    graph: SankeyDiagramGraph,
    nodeVal: NodeValues[],
    refValue: number,
    configDecimalPlace?: number,
    configPercentagesDecimalPlaces = 1
): string[] => {
    const mapped = graph.nodes.map(n => {
        const node = nodeVal.find(item => item.nodeName === n.id);
        const val = node ? node.value : 0;
        const index = node ? nodeVal.indexOf(node) : -1;

        return `${n.title}<br> ${getPercentage(val, refValue).toFixed(
            configPercentagesDecimalPlaces
        )}% | ${val.toFixed(configDecimalPlace || nodeVal[index].decimalPlace)} ${nodeVal[index].unit}`;
    });

    return Array.from(mapped);
};

export const extractValue = (val: number, configDecimalPlace: number) => {
    if (val <= minimalNumber) {
        return 0;
    } else {
        return val.toFixed(configDecimalPlace);
    }
};

export const makeCustomData = (value: number | undefined, unit: string | undefined, title: string | undefined, date: string | undefined, sourceNodeTitle: string | undefined, nodeValue: number | undefined) => {
    return `${value && value >= minimalNumber ? value : 0} ${unit || ""}<br>${sourceNodeTitle && value && nodeValue ? `${(value * 100 / nodeValue).toFixed(2)}% nuo ${sourceNodeTitle}<br>` : ""}${title || ""}<br>${date ? dateToReadableString(new Date(date)) : ""}`;
};

export const timeSetWithConfig = (refTime: string | undefined, dateConfig: {
    alignStartTo?: ChronoUnitLegacy,
    timeOffset?: number,
    timeOffsetUnits?: ChronoUnitLegacy
}): Date => {
    if (refTime) {
        return new Date(refTime);
    }

    let tempDate = new Date();

    if (dateConfig.alignStartTo) {
        tempDate = truncateDate(tempDate, dateConfig.alignStartTo);
    }

    if (dateConfig.timeOffset != null || dateConfig.timeOffsetUnits) {
        tempDate = addToDate(tempDate,
            dateConfig.timeOffset != null ? dateConfig.timeOffset : 0,
            dateConfig.timeOffsetUnits || ChronoUnitLegacy.MINUTES);
    }

    return tempDate;
};